import { render, staticRenderFns } from "./PageCode.vue?vue&type=template&id=443ee53e&scoped=true&"
import script from "./PageCode.vue?vue&type=script&lang=js&"
export * from "./PageCode.vue?vue&type=script&lang=js&"
import style0 from "./PageCode.vue?vue&type=style&index=0&id=443ee53e&prod&lang=scss&"
import style1 from "./PageCode.vue?vue&type=style&index=1&id=443ee53e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443ee53e",
  null
  
)

export default component.exports